// Numbered pagination — "‹ 1 … 4 5 6 … 12 ›" with a "1–6 of 17" count beneath.
// Kept generic (no collection/product wording) so the brand dashboard's product
// grid can reuse it. Purely presentational: the caller owns `page` and slices
// its own list.
const Pager = ({ page, pageCount, onPage, total, pageSize, label = 'items' }) => {
    if (pageCount <= 1) return null;

    // Always show first, last and the current page's neighbours; the gaps
    // between those groups collapse into an ellipsis.
    const nums = [];
    for (const n of [1, page - 1, page, page + 1, pageCount]) {
        if (n >= 1 && n <= pageCount && !nums.includes(n)) nums.push(n);
    }
    nums.sort((a, b) => a - b);

    const cells = [];
    nums.forEach((n, i) => {
        if (i > 0 && n - nums[i - 1] > 1) cells.push({ gap: true, key: `gap${n}` });
        cells.push({ n, key: n });
    });

    const first = (page - 1) * pageSize + 1;
    const last = Math.min(page * pageSize, total);

    return (
        <>
            <nav className="pager" aria-label="Pagination">
                <button
                    type="button"
                    className="pager-btn"
                    onClick={() => onPage(page - 1)}
                    disabled={page === 1}
                    aria-label="Previous page"
                >‹</button>

                {cells.map(c => (
                    c.gap
                        ? <span key={c.key} className="pager-gap" aria-hidden="true">…</span>
                        : (
                            <button
                                key={c.key}
                                type="button"
                                className={`pager-btn${c.n === page ? ' is-current' : ''}`}
                                onClick={() => onPage(c.n)}
                                aria-label={`Page ${c.n}`}
                                aria-current={c.n === page ? 'page' : undefined}
                            >{c.n}</button>
                        )
                ))}

                <button
                    type="button"
                    className="pager-btn"
                    onClick={() => onPage(page + 1)}
                    disabled={page === pageCount}
                    aria-label="Next page"
                >›</button>
            </nav>
            <p className="pager-count">{first}–{last} of {total} {label}</p>
        </>
    );
};

export default Pager;
